import { api } from "@lib/orpc-client"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import * as Sentry from "@sentry/react"

const useCryptoDepositAddress = () => {
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const getDepositAddress = async (assetId: string) => {
        try {
            setError(null)
            setIsLoading(true)
            const response = await api.wallet.requestDepositAddress({
                asset: assetId,
            })
            return response.address
        } catch (error) {
            Sentry.captureException(error)
            setError(t('errors.1007.description'))
            throw error
        } finally {
            setIsLoading(false)
        }
    }

    return {
        isLoading,
        error,
        getDepositAddress
    }
}

export default useCryptoDepositAddress
